import React from 'react';
import { bookData } from '../data/mockData';
import { Award, BookOpen, Briefcase } from 'lucide-react';

const AuthorSection = () => {
  return (
    <section id="author" className="py-24 lg:py-32 bg-[#302f2c]">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="mb-6 inline-block">
              <span className="caption text-[#d9fb06] bg-[#3f4816] px-4 py-2 rounded-full">
                SOBRE LOS AUTORES
              </span>
            </div>
            
            <h2 className="heading-2 text-[#d9fb06] mb-4">
              Expertos en Marca Personal Deportiva
            </h2>
          </div>

          {/* Authors Grid */}
          <div className="space-y-16">
            {bookData.authors.map((author, index) => (
              <div 
                key={index}
                className={`grid lg:grid-cols-5 gap-8 lg:gap-12 items-start ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                }`}
              >
                {/* Author Image */}
                <div className={`lg:col-span-2 ${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                  <div className="relative">
                    <div className="aspect-[3/4] bg-[#1a1c1b] rounded-lg overflow-hidden border-2 border-[#3f4816]">
                      <img
                        src={author.photo}
                        alt={author.name}
                        className="w-full h-full object-cover object-center"
                      />
                    </div>
                    <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#d9fb06] opacity-20 rounded-full blur-2xl"></div>
                  </div>
                </div>

                {/* Author Info */}
                <div className={`lg:col-span-3 ${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                  {/* Name */}
                  <h3 className="heading-4 text-[#d9fb06] mb-4">
                    {author.name}
                  </h3>

                  {/* Bio */}
                  <p className="body-medium text-[#dfddd6] mb-8 leading-relaxed">
                    {author.bio}
                  </p>

                  {/* Credentials */}
                  <div className="mb-8">
                    <h4 className="heading-6 text-[#d9fb06] mb-4 flex items-center gap-2">
                      <Award size={20} />
                      Credenciales Profesionales
                    </h4>
                    <div className="grid sm:grid-cols-2 gap-3">
                      {author.credentials.map((credential, credIndex) => (
                        <div key={credIndex} className="flex items-start gap-2">
                          <div className="w-2 h-2 bg-[#d9fb06] rounded-full mt-2 flex-shrink-0"></div>
                          <span className="body-small text-[#888680]">{credential}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Highlights */}
                  {author.highlights && (
                    <div className="grid sm:grid-cols-2 gap-4">
                      {author.highlights.map((highlight, highlightIndex) => (
                        <div 
                          key={highlightIndex}
                          className="bg-[#1a1c1b] border border-[#3f4816] rounded-lg p-4"
                        >
                          <div className="w-10 h-10 rounded-lg bg-[#3f4816] flex items-center justify-center mb-3">
                            {highlightIndex === 0 ? (
                              <Briefcase className="text-[#d9fb06]" size={20} />
                            ) : (
                              <BookOpen className="text-[#d9fb06]" size={20} />
                            )}
                          </div>
                          <h5 className="heading-6 text-[#d9fb06] mb-2">
                            {highlight.title}
                          </h5>
                          <p className="body-small text-[#888680]">
                            {highlight.description}
                          </p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AuthorSection;
